import {create} from "zustand";
import { NewsAndOffersStatus, NewsAndOffersType } from '@/features/news-and-offers/types/news-and-offers-dto';

type NewsAndOffersFilter = {
    filter: {
        startDate?: Date | null;
        endDate?: Date | null;
        types?: NewsAndOffersType[];
        statuses?: NewsAndOffersStatus[];
    },
    setFilter: ( filter: NewsAndOffersFilter['filter'] ) => void;
    resetFilter: () => void;
};

export const useNewsAndOffersFilter = create<NewsAndOffersFilter>((set) => ({
    filter: {
        startDate: undefined, 
        endDate: undefined,
        types: undefined,
        statuses: undefined
    },
    setFilter: (filter) => {
        set({
            filter: {
                ...filter
            },
        });
    },
    resetFilter: () => {
        set({ 
            filter: {
                startDate: null, 
                endDate: null,
                types: [],
                statuses: [] 
            } 
        });
    },
}));